import A5RecalculateButton from "./client/a5_recalculate_button";
import A5GeneratePdf from "./client/a5_generate_pdf";
import L1RecalculateButton from "./client/l1_recalculate_button";
import N1RecalculateButton from "./client/n1_recalculate_button";
import A6GeneratePdf from "./client/a6_generate_pdf";
import C5GeneratePdf from "./client/c5_generate_pdf";
import E3GeneratePdf from "./client/e3_generate_pdf";
import S3GeneratePdf from "./client/s3_generate_pdf";
import A6RecalculateButton from "./client/a6_recalculate_button";
import C5RecalculateButton from "./client/c5_recalculate_button";
import E3RecalculateButton from "./client/e3_recalculate_button";
import A7FIAGenerateEDDExports from "./client/a7_fia_generate_edd_exports";
import A7FIAGeneratePdf from "./client/a7_fia_generate_pdf";
import A7FIALoadTemplates from "./client/a7_fia_load_templates";
import A7OPCVMGenerateEDDExports from "./client/a7_opcvm_generate_edd_exports";
import A7OPCVMLoadTemplates from "./client/a7_opcvm_load_templates";
import S3RecalculateButton from "./client/s3_recalculate_button";
import K2RecalculateButton from "./client/k2_recalculate_button";
import K2GeneratePdf from "./client/k2_generate_pdf";
import A7FIARunCalcPopover from "./client/a7_fia_run_calc_popover";
import A7OPCVMRunCalcPopover from "./client/a7_opcvm_run_calc_popover";
import K1RecalculateButton from "./client/k1_recalculate_button";
import R1RecalculateButton from "./client/r1_recalculate_button";
import A7OPCVMGeneratePdf from "./client/a7_opcvm_generate_pdf";
import S1InstitGeneratePdf from "./client/s1_instit_generate_pdf";
import D1RecalculateButton from "./client/d1_recalculate_button";
import D1GeneratePdf from "./client/d1_generate_pdf";
import {
  C3RunLookthroughButton,
  E2GenerateExcelButton,
  E2GeneratePdfButton,
  E2RunLookthroughButton,
  G4GenerateEsgConsolideButton,
  G4GenerateTranspaButton,
  G4RunLookthroughButton,
} from "./client/lookthrough_export_buttons";
import G4GenerateReportWithoutLookThrough from "./client/g4_generate_report_without_lookthrough";
import {
  C3SyncTptReceptionButton,
  C7SyncTptReceptionButton,
  E2SyncTptReceptionButton,
  G4SyncTptReceptionButton,
  I1SyncTptReceptionButton,
} from "./client/sync_tpt_reception_button";
import C3RecalculateButton from "./client/c3_recalculate_button";
import I1GenerateExport from "./client/i1_generate_export";
import {
  C3RunCalcPopover,
  I1RunCalcPopover,
  S1RunCalcPopover,
} from "./client/run_calc_popover";

import { Groups } from "@/lib/groups";

import { Clients } from "@/lib/clients";

type TClientConfig = {
  prefix: ReadonlyArray<string>;
  actions: ReadonlyArray<{
    button: React.ReactNode;
    groups: ReadonlyArray<string>;
  }>;
};

export const clientConfig: Record<string, TClientConfig> = {
  a5: {
    prefix: ["a5"],
    actions: [
      {
        button: <A5RecalculateButton />,
        groups: ["a5-users", "a5-quantilia"],
      },
      {
        button: <A5GeneratePdf />,
        groups: ["a5-users", "a5-quantilia"],
      },
    ],
  },
  a6: {
    prefix: ["a6"],
    actions: [
      {
        button: <A6RecalculateButton />,
        groups: ["a6-users", "a6-quantilia"],
      },
      {
        button: <A6GeneratePdf />,
        groups: ["a6-users", "a6-quantilia"],
      },
    ],
  },
  [Clients.C3]: {
    prefix: [Clients.C3],
    actions: [
      {
        button: <C3RecalculateButton />,
        groups: [Groups.C3_USERS, Groups.C3_QUANTILIA],
      },
      {
        button: <C3RunLookthroughButton />,
        groups: [Groups.C3_QUANTILIA],
      },
      {
        button: <C3RunCalcPopover />,
        groups: [Groups.C3_QUANTILIA],
      },
      {
        button: <C3SyncTptReceptionButton />,
        groups: [Groups.C3_QUANTILIA],
      },
    ],
  },
  [Clients.C5]: {
    prefix: [Clients.C5],
    actions: [
      {
        button: <C5RecalculateButton />,
        groups: [Groups.C5_USERS, Groups.C5_QUANTILIA],
      },
      {
        button: <C5GeneratePdf />,
        groups: [Groups.C5_USERS, Groups.C5_QUANTILIA],
      },
    ],
  },
  [Clients.C7]: {
    prefix: [Clients.C7],
    actions: [
      {
        button: <C7SyncTptReceptionButton />,
        groups: [Groups.C7_QUANTILIA],
      },
    ],
  },
  [Clients.D1]: {
    prefix: [Clients.D1],
    actions: [
      {
        button: <D1RecalculateButton />,
        groups: [Groups.D1_USERS, Groups.D1_QUANTILIA],
      },
      {
        button: <D1GeneratePdf />,
        groups: [Groups.D1_USERS, Groups.D1_QUANTILIA],
      },
    ],
  },
  [Clients.E2]: {
    prefix: [Clients.E2],
    actions: [
      {
        button: <E2RunLookthroughButton />,
        groups: [Groups.E2_USERS, Groups.E2_QUANTILIA],
      },
      {
        button: <E2GeneratePdfButton />,
        groups: [Groups.E2_USERS, Groups.E2_QUANTILIA],
      },
      {
        button: <E2GenerateExcelButton />,
        groups: [Groups.E2_USERS, Groups.E2_QUANTILIA],
      },
      {
        button: <E2SyncTptReceptionButton />,
        groups: [Groups.E2_QUANTILIA],
      },
    ],
  },
  e3: {
    prefix: ["e3"],
    actions: [
      {
        button: <E3RecalculateButton />,
        groups: ["e3-users", "e3-quantilia"],
      },
      {
        button: <E3GeneratePdf />,
        groups: ["e3-users", "e3-quantilia"],
      },
    ],
  },
  l1: {
    prefix: ["l1"],
    actions: [
      {
        button: <L1RecalculateButton />,
        groups: ["l1-users", "l1-quantilia"],
      },
    ],
  },
  n1: {
    prefix: ["n1"],
    actions: [
      {
        button: <N1RecalculateButton />,
        groups: ["n1-users", "n1-quantilia"],
      },
    ],
  },
  k1: {
    prefix: ["k1"],
    actions: [
      {
        button: <K1RecalculateButton />,
        groups: ["k1-users", "k1-quantilia"],
      },
    ],
  },
  r1: {
    prefix: ["r1"],
    actions: [
      {
        button: <R1RecalculateButton />,
        groups: ["r1-users", "r1-quantilia"],
      },
    ],
  },
  k2: {
    prefix: ["k2"],
    actions: [
      {
        button: <K2RecalculateButton />,
        groups: ["k2-users", "k2-quantilia"],
      },
      {
        button: <K2GeneratePdf />,
        groups: ["k2-users", "k2-quantilia"],
      },
    ],
  },
  [Clients.G4]: {
    prefix: [Clients.G4],
    actions: [
      {
        button: <G4RunLookthroughButton />,
        groups: [Groups.G4_USERS, Groups.G4_QUANTILIA],
      },
      {
        button: <G4GenerateTranspaButton />,
        groups: [Groups.G4_USERS, Groups.G4_QUANTILIA],
      },
      {
        button: <G4GenerateReportWithoutLookThrough />,
        groups: [Groups.G4_USERS, Groups.G4_QUANTILIA],
      },
      {
        button: <G4GenerateEsgConsolideButton />,
        groups: [Groups.G4_USERS, Groups.G4_QUANTILIA],
      },
      {
        button: <G4SyncTptReceptionButton />,
        groups: [Groups.G4_QUANTILIA],
      },
    ],
  },
  [Clients.I1]: {
    prefix: [Clients.I1],
    actions: [
      {
        button: <I1GenerateExport />,
        groups: [Groups.I1_QUANTILIA],
      },
      {
        button: <I1RunCalcPopover />,
        groups: [Groups.I1_QUANTILIA],
      },
      {
        button: <I1SyncTptReceptionButton />,
        groups: [Groups.I1_QUANTILIA],
      },
    ],
  },
  s3: {
    prefix: [Clients.S3],
    actions: [
      {
        button: <S3RecalculateButton />,
        groups: ["s3-users", "s3-quantilia"],
      },
      {
        button: <S3GeneratePdf />,
        groups: ["s3-users", "s3-quantilia"],
      },
    ],
  },
  "s1-instit": {
    prefix: ["s1"],
    actions: [
      {
        button: <S1InstitGeneratePdf />,
        groups: ["s1-users", "s1-quantilia"],
      },
      {
        button: <S1RunCalcPopover />,
        groups: ["s1-quantilia"],
      },
    ],
  },
  "a7-fia": {
    prefix: ["a7-fia"],
    actions: [
      {
        button: <A7FIALoadTemplates />,
        groups: ["a7-fia-quantilia"],
      },
      {
        button: <A7FIARunCalcPopover />,
        groups: ["a7-users-admin", "a7-users-fia", "a7-fia-quantilia"],
      },
      {
        button: <A7FIAGeneratePdf />,
        groups: ["a7-users-admin", "a7-users-fia", "a7-fia-quantilia"],
      },
      {
        button: <A7FIAGenerateEDDExports />,
        groups: ["a7-fia-quantilia"],
      },
    ],
  },
  "a7-opcvm": {
    prefix: ["a7-opcvm"],
    actions: [
      {
        button: <A7OPCVMLoadTemplates />,
        groups: ["a7-opcvm-quantilia"],
      },
      {
        button: <A7OPCVMRunCalcPopover />,
        groups: ["a7-users-admin", "a7-users-opcvm", "a7-opcvm-quantilia"],
      },
      {
        button: <A7OPCVMGeneratePdf />,
        groups: ["a7-users-admin", "a7-users-opcvm", "a7-opcvm-quantilia"],
      },
      {
        button: <A7OPCVMGenerateEDDExports />,
        groups: ["a7-opcvm-quantilia"],
      },
    ],
  },
};
